<div class="configuration-accelerators-accelerators-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="accelerators()"></grid-content>
</div>